import { render, staticRenderFns } from "./CollectionParameter.vue?vue&type=template&id=4b55eb39"
import script from "./CollectionParameter.vue?vue&type=script&lang=ts"
export * from "./CollectionParameter.vue?vue&type=script&lang=ts"
import style0 from "./CollectionParameter.vue?vue&type=style&index=0&id=4b55eb39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports